/**
 *  @class
 *  @function UniversalDivider
 */

if (!customElements.get('universal-divider')) {
  class UniversalDivider extends HTMLElement {
    constructor() {
      super();
      this.tl = false;
    }

    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }

    disconnectedCallback() {
      if (this.tl) {
        this.tl.kill();
      }
    }

    prepareAnimations() {
      let section = this;
      let line = section.querySelector('.universal-divider--line');

      if (!line) return;

      gsap.set(line, { scaleX: 0 });

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center+=100"
        }
      });

      section.tl.to(line, {
        duration: 1,
        scaleX: 1,
        ease: "power2.out"
      });
    }
  }
  customElements.define('universal-divider', UniversalDivider);
}
